import { timestampToFomattedDate } from '../../utils/date'
import { getEmptyGroup } from '../../utils/groups'
import { EMPTY_RAW_SESSION_EVENT_DATA } from '../events'
import { sportTypes } from '../sports'
import {
  EMPTY_SESSION_SUB_TYPE_CONFIG,
  EMPTY_SESSION_TYPE_CONFIG,
  EMPTY_SPORT_CONFIG
} from '../sports/constants'
import { EMPTY_FORMATTED_TEAM, EMPTY_RAW_TEAM_DATA } from '../teams/constants'
import {
  sessionModeTypes,
  sessionStateTypes,
  sessionTypes,
  subSessionTypes
} from './data_types'
import { FormattedSession, ProcessedSessionEvent } from './types'

export const EMPTY_PROCESSED_SESSION: ProcessedSessionEvent = {
  ...EMPTY_RAW_SESSION_EVENT_DATA,

  rawData: EMPTY_RAW_SESSION_EVENT_DATA,

  typeConfig: EMPTY_SESSION_TYPE_CONFIG,
  subTypeConfig: EMPTY_SESSION_SUB_TYPE_CONFIG,

  mode: sessionModeTypes.getTypeByValue(null),

  state: sessionStateTypes.getTypeByValue(null),
  isNotStarted: false,
  isStarted: false,
  isFinished: false,
  isLocal: false,

  sport: sportTypes.getTypeByValue(null),
  sportConfig: EMPTY_SPORT_CONFIG,

  homeTeam: EMPTY_RAW_TEAM_DATA,
  awayTeam: EMPTY_RAW_TEAM_DATA,
  taggedPlayerCount: 0,
  playerCount: 0,
  ballCount: 0,

  startTime: timestampToFomattedDate('0'),
  endTime: timestampToFomattedDate('0'),

  tags: []
}

export const EMPTY_FORMATTED_SESSION: FormattedSession = {
  sessionData: EMPTY_RAW_SESSION_EVENT_DATA.data,
  sessionEvent: EMPTY_RAW_SESSION_EVENT_DATA,
  isSetup: false,
  id: '',
  name: '',
  startTime: timestampToFomattedDate('0'),
  endTime: timestampToFomattedDate('0'),
  sport: sportTypes.getTypeByValue(null),
  type: sessionTypes.getTypeByValue(null),
  subType: subSessionTypes.getTypeByValue(null),
  mode: sessionModeTypes.getTypeByValue(null),
  state: sessionStateTypes.getTypeByValue(null),
  liveOnDevice: false,
  live: false,
  isTrainingMode: false,
  isMatchMode: false,
  hostname: '',
  locationName: '',
  teams: getEmptyGroup(),
  teamSessions: getEmptyGroup(),
  players: {
    All: getEmptyGroup(),
    byTeamPersonSessionId: getEmptyGroup()
  },
  playersSessions: {
    byHardwareId: getEmptyGroup(),
    byNumber: {},
    byPlayerId: getEmptyGroup(),
    byId: getEmptyGroup()
  },
  homeTeam: EMPTY_FORMATTED_TEAM,
  awayTeam: EMPTY_FORMATTED_TEAM,
  balls: getEmptyGroup(),
  sessionEventConfig: EMPTY_SESSION_SUB_TYPE_CONFIG,
  playerSummaryMetrics: {},
  pitchId: '',
  pitch: {
    sport: null,
    coordinates: {},
    arcs: []
  },
  rawPitch: {} as any,
  anchorConfig: {},
  anchors: getEmptyGroup(),
  homeSideCheck: false
}
